import { render } from "./JournalGrades.vue?vue&type=template&id=39dff7c2"
import script from "./JournalGrades.vue?vue&type=script&lang=js"
export * from "./JournalGrades.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/JournalGrades.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39dff7c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39dff7c2', __exports__)) {
    api.reload('39dff7c2', __exports__)
  }
  
  module.hot.accept("./JournalGrades.vue?vue&type=template&id=39dff7c2", () => {
    api.rerender('39dff7c2', render)
  })

}


export default __exports__